import { TranslatedTextDto } from "../TranslatedText/TranslatedTextDto";

export interface CustomerConditionDto {
    customerConditionId: number;
    name: string;
    isActive: boolean;
    discountScheduleId: number;
    discountId: number;
    validFrom: string;
    validTo: string;
    sequenceNumber: number;
}

export interface BenefitsCustomDataDto {
    customerConditionId: number;
    name: TranslatedTextDto;
    description: TranslatedTextDto;
    label: TranslatedTextDto;
    thumbnail: number;
    modal: number;
    icon: string;
    backgroundColor: string;
    isVisible: boolean;
    isShareable: boolean;
}

export interface BenefitsCustomDataViewModel {
    // #region BenefitsCustomDataDto
    customerConditionId: number;
    name: TranslatedTextDto;
    description: TranslatedTextDto;
    label: TranslatedTextDto;
    thumbnail: number;
    modal: number;
    icon: string;
    backgroundColor: string;
    isVisible: boolean;
    isShareable: boolean;
    // #endregion BenefitsCustomDataDto

    // #region CustomerConditionDto
    isActive: boolean;
    discountScheduleId: number;
    discountId: number;
    validFrom: string;
    validTo: string;
    sequenceNumber: number;
    // #endregion CustomerConditionDto

    // #region CustomerPromoCodeDto
    customerAccountNr: number;
    promotionName: string;
    promocode: string;
    promocodeTypeNr: number;
    promocodeType: string;
    maxUsages: number;
    usages: number;
    remainUsages: number;
    isOwner: boolean;
    attributeNr: number;
    products: CustomerPromoCodeProductDto[];
    // #endregion CustomerPromoCodeDto

    isEmpty: boolean; // If customerConditionId == 0 and promocode == ''
}

export interface CustomerPromoCodeProductDto {
    lfdNr: number;
    conditionNr: number;
    fieldName: string;
    operandNumber: number;
    operandName: string;
    value: string;
    valueDescription: string;
}

export enum BenefitTypesEnum {
    Normal,
    Used,
    Expired,
    Invalid,
}